import React from "react";
import { Modal } from "antd";

import styled from "@emotion/styled";
import { mq } from "@/libs/react-responsive/mediaQuery";

const Container = styled(Modal)(({ width }) => ({
  minWidth: "80vw",

  "&>div": {
    margin: 0,
    overflow: "scroll",
  },

  [mq("tablet")]: {
    minWidth: width ? width : "80vw",
  },
}));

const ModalContainer = ({ children, width, ...props }) => {
  const modalStyles = {
    mask: {
      zIndex: 500,
    },
  };

  return (
    <Container
      {...props}
      styles={modalStyles}
      zIndex={5000}
      width={width}
      centered
      cancelText={props.cancelText ? props.cancelText : "취소"}
      wrapClassName="antd-modal-wrapper"
      destroyOnClose={true}
    >
      {children}
    </Container>
  );
};

export default ModalContainer;
